import { gql } from '@apollo/client';
import { OrderType } from '../../../../graphql/types/OrderType';

export const GET_PENDING_CLOSE_ORDERS = gql`
    query GetPendingCloseOrders(
        $filters: OrderCloseFiltersInput
        $pageRequest: PageRequestTypeInput
    ) {
        getPendingCloseOrders(filters: $filters, pageRequest: $pageRequest) {
            content {
                ...OrderFields
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
    
    fragment OrderFields on OrderType {
        id
        trackingNumber
        channelOrderNumber
        overallStatus
        sortingCode
        deliveredDspId
        receivedAtHub
        destWarehouseArrivedAt
        deliverAt
        lastDeliveryScanTime
        isHasBeenSetException
        isAbnormal
        exceptionStatus
        exceptionReasonCode
        markExceptionAt
        nextAction
        deliveredDriverAccountId
        lastAssignedDriverName
        daysFromAscan
        hoursToClose
        flowType
        createdAt
        updatedAt
        channel {
            id
            clientCode
            channelName
        }
        dsp {
            id
            name
        }
        latestCloseRecord {
            id
            closeTime
            closeOperatorAccountId
            closeOperatorAccountName
            closeType
        }
    }
`;

export interface OrderCloseFiltersInput {
    trackingNumbers?: string;
    referenceNos?: string[];
    channelOrderNumber?: string;  // 渠道订单号（与总部页面保持一致）
    clientCodes?: string[];
    channelIds?: number[];
    deliveredDspIds?: number[];
    daysFromAscan?: {
        min?: number;
        max?: number;
    };
    hoursToClose?: {
        min?: number;
        max?: number;
    };
    hasException?: boolean;
    exceptionStatuses?: number[];
    hasCloseRecord?: boolean; // 是否有关单记录（true=已关单，false=未关单，null=全部）
    flowType?: string; // 包裹所属流程：FORWARD_UNCLOSED-正向未闭环，REVERSE_UNCLOSED-逆向未闭环；不传则同时展示两种
    // 以下字段用于UI状态保存，后端可能暂不支持
    overallStatuses?: string[];
    hubId?: string;
    warehouseId?: string;
    sortingCodeSegment1?: string;
    sortingCodeSegment2?: string;
    sortingCodeSegment3?: string;
    receiverZipcode?: string[];
    receiverZipcodeInput?: string; // UI状态：原始输入字符串
    pickupHubId?: string[]; // UI状态：使用pickupHubId与总部保持一致
    pickupHubIds?: number[]; // 保留兼容性
    cooperationWarehouseId?: number; // 揽收站点ID
    orderTime?: [string | null, string | null] | null;
    receivedAtHub?: [string | null, string | null] | null;
    deliveredAt?: [string | null, string | null] | null;
    destHubArrivedAt?: [string | null, string | null] | null;
    destWarehouseArrivedAt?: [string | null, string | null] | null;
    lastDeliveryScanTime?: [string | null, string | null] | null;
    deliverAt?: [string | null, string | null] | null;
    updatedAt?: [string | null, string | null] | null;
    returnArrivalHubAt?: [string | null, string | null] | null;
    lastExceptionReason?: string;
    exceptionReasonCode?: string; // UI状态：使用exceptionReasonCode与总部保持一致
    markExceptionAt?: [string | null, string | null] | null;
    nextAction?: string;
    nextActions?: string[]; // UI状态：多选下一步动作
    isComplaint?: boolean; // 是否投诉
    podReviewStatus?: string; // POD审核状态
    isHasBeenSetException?: boolean; // 是否已设置异常（与总部保持一致）
    isAbnormal?: boolean; // 异常状态（与总部保持一致）
    closeTime?: [string | null, string | null] | null; // 关单时间范围
    closeOperatorAccountId?: number; // 关单操作人账户ID
}

export interface PageRequestInput {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

export interface GetPendingCloseOrdersResponse {
    getPendingCloseOrders: {
        content: OrderType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}
